import { ChangeDetectionStrategy, Component, OnInit, ViewChild } from '@angular/core';
import { DynamicFormField, FormFieldTypes } from 'src/app/ui/dynamic-form/dynamicFormTypes';
import { IconService } from 'src/app/ui/icon.service';
import { IconObject } from 'src/app/ui/uiInterfaces';
import { Table } from 'primeng/table';
import { ConfirmationService, MessageService, MenuItem } from 'primeng/api';
import { Popover } from 'primeng/popover';
import { Column } from 'src/app/ui/tables';
import { FormBuilder } from '@angular/forms';

@Component({
    selector: 'app-style-guide',
    templateUrl: './style-guide.component.html',
    styleUrl: './style-guide.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class StyleGuideComponent implements OnInit {

    constructor(
        public icons: IconService,
        private confirmationService: ConfirmationService,
        private messageService: MessageService,
        private fb: FormBuilder
    ) {}

    ngOnInit() {
        this.getIcons(this.iconObjList);
    }

    @ViewChild('dt2') dt2!: Table;
    @ViewChild('pop') pop!: Popover;

    date: Date = new Date();
    phone: string = '';
    switchBool: boolean = false;
    selectedOption: any;
    radio: any;
    checked: boolean = false;
    dialogVisible: boolean = false;
    selectedFont: any = {
        name: 'Public Sans'
    }

    form = this.fb.group({
        editor: ['']
    })

    columns: Column<any>[] = [
        {field: "id", header: "ID", type: "number",  },
        {field: "name", header: "Name", type: "string"},
        {field: "numbers", header: "Numbers", type: "number",  }
      ]

    iconObjList = [
        {
            name: 'solid',
            iconObj: this.icons.solid,
            icons: [] as any
        },
        {
            name: 'regular',
            iconObj: this.icons.regular,
            icons: [] as any
        },
        {
            name: 'ppmSolid',
            iconObj: this.icons.ppmSolid,
            icons: [] as any
        },
        {
            name: 'ppmRegular',
            iconObj: this.icons.ppmRegular,
            icons: [] as any
        }
    ]

    colorClassList = [
        'primary-background',
        'secondary-background',
        'tertiary-background',
        'accent-background',
        ''
    ]

    severityColorClassList = [
        'info-background',
        'success-background',
        'warn-background',
        'help-background',
        'danger-background',
        'selected-background'
    ]

    editorField: DynamicFormField = {
        id: 'editor',
        name: '',
        type: FormFieldTypes.textarea,
        value: '',
        text: '', 
        hideName: true
    }

    selectData = [
        {
            id: 1,
            value: 'This'
        },
        {
            id: 2,
            value: 'That'
        },
        {
            id: 3,
            value: 'A third thing'
        },
        {
            id: 4,
            value: 'Something else'
        },
        {
            id: 5,
            value: 'Another option?'
        },
        {
            id: 6,
            value: 'Last but not least'
        },
    ]

    menuItems: MenuItem[] = [
        {
            label: 'Item 1'
        },
        {
            label: 'Item 2'
        },
        {
            label: 'Item 3'
        }
    ]

    tableData = [
        {
            id: 1,
            name: 'John',
            numbers: 1234
        },
        {
            id: 2,
            name: 'Jane',
            numbers: 123456
        },
        {
            id: 3,
            name: 'James',
            numbers: 12345
        },
        {
            id: 4,
            name: 'Janet',
            numbers: 1234
        },
        {
            id: 5,
            name: 'Jack',
            numbers: 123455
        },
        {
            id: 6,
            name: 'Jodie',
            numbers: 123478
        }
    ]

    dataViewData = [
        {
            id: 1,
            group: 'First Christian Church',
            location: 'Western North Carolina',
            date: '05/05/25',
            tl: 'Ben Jamin'
        },
        {
            id: 2,
            group: 'Second Christian Church',
            location: 'Belize',
            date: '06/05/25',
            tl: 'Ronnie Aldo'
        },
        {
            id: 3,
            group: 'Youth Group',
            location: 'New York',
            date: '07/05/25',
            tl: 'Gertrude Lastname'
        },
        {
            id: 4,
            group: 'Transyvania Church',
            location: 'Greece',
            date: '08/05/25',
            tl: 'Ben Jamin'
        },
        {
            id: 5,
            group: 'Church Church',
            location: 'Colorado',
            date: '09/05/25',
            tl: 'Hilary Hiker'
        }
    ]

    getIcons(iconObjList: any[]) {
        iconObjList?.forEach((obj: any) => {
            Object.keys(obj.iconObj).forEach((key: any) => {
                console.log(obj.iconObj)
                obj.icons.push(
                    {
                        name: key, 
                        icon: obj.iconObj[key]
                    }
                )
            })
        })
    }

    filterTableGlobal(e: any) {
        this.dt2.filterGlobal(e.target.value, 'contains');
    }

    confirmDialog(event: Event) {
        this.confirmationService.confirm({
            target: event.target as EventTarget,
            message: 'Are you sure that you want to proceed?',
            header: 'Confirmation',
            closable: true,
            closeOnEscape: true,
            icon: 'pi pi-exclamation-triangle',
            rejectButtonProps: {
                label: 'Cancel',
                severity: 'secondary',
                outlined: true,
            },
            acceptButtonProps: {
                label: 'Confirm',
            },
            accept: () => {
                this.messageService.add({ severity: 'info', summary: 'Confirmed', detail: 'You have accepted' });
            },
            reject: () => {
                this.messageService.add({
                    severity: 'error',
                    summary: 'Rejected',
                    detail: 'You have rejected',
                    life: 3000,
                });
            },
        });
    }

    showDialog() {
        this.dialogVisible = true;
    }

    showPopover(e: any) {
        this.pop.show(e);
    }

}
